define('modules/editor/behaviours/modal_movable',['require','exports','module','../models/editorstate'],function(require, exports, module){
	"use strict";

	var EditorState = require("../models/editorstate"),
			MoveState = EditorState.moveState;

	/**
	 * Movable events
	 * @type {Object}
	 */
	var MovableEvents = {
		"mousedown": "_onMovableMouseDown"
	};

	//store drappable target elements for collision detection
	var targets = [];

	/**
	 * Binds mouse event handlers and prevents selection
	 * on the whole page
	 */
	var _bindMouseHandlers = function(){
		//bind events for dragging and stopping
		$(document).on("mousemove", _continueDragging);
		$(document).on("mouseup", _endDrag);
		$(".js-page").addClass("noselect");
	};
	/**
	 * Unbinds mouse event handlers and removes whole page CSS class
	 * that prevents selecting
	 * @return {[type]}
	 */
	var _unbindMouseHandlers = function(){
		$(document).unbind("mousemove", _continueDragging);
		$(document).unbind("mouseup", _endDrag);
		$(".js-page").removeClass("noselect");
	};

	/**
	 * Event handler for mouse move event
	 * @param  {Event} e
	 */
	var _continueDragging = function(e){
		//update the location of the moving view
		var isOver = false,
				movingView = MoveState.getMovingView(),
				parentElement = movingView.$el.parent(),
				offset = MoveState.getClickOffset();

		movingView.$el.css({
			left: parseInt(e.clientX - offset.left),
			top: parseInt(e.clientY - offset.top)
		});

		movingView.$el.toggleClass("offlimits", !isOver);
		//store absolute coords
		MoveState.setLastPosition(e.pageX, e.pageY);
	};

	/**
	 * Event handler for mouseup event
	 * @param  {Event} e
	 */
	var _endDrag = function(e){
		var movingItem = MoveState.getMovingView(),
				dropTargetFound = false,
				originalPos;

		//remove event listeners
		_unbindMouseHandlers();
		MoveState.stopMoving();
	};

	/**
	 * Movable View Behaviour
	 * Handles drag & drop moving of elements ALREADY in the editor
	 * @type {Object}
	 */
	var ModalMovable = {
		_onMovableMouseDown: function(e){
			//left button only
			if(e.which !== 1) {
				return;
			}
      if($(e.target).is('div')) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        //store the click offset to be able to drag / drop with accuracy
        var clickOffset = {
          top: e.pageY - this.$el.offset().top,
          left: e.pageX - this.$el.offset().left
        };
        //keep a reference to the moving view
        MoveState.startMoving(this, clickOffset);
        _bindMouseHandlers();
      }
		},
		mixed: function(klass, proto){
			proto.events = _.extend(proto.events || {}, MovableEvents);
		}
	};

	module.exports = ModalMovable;
});

